const requestUtil = require('../../shared/util/request');
const apiUrl = require('./apiUrl');

function sendTestFitFormEmail(testFitFormData, onSuccess = () => {}, onFailure = () => {}) {
  return requestUtil.jsonPostWithCredentials(apiUrl('/testFitForm'), testFitFormData)
    .then(() => onSuccess())
    .catch(err => onFailure(err));
}

function createSource(sourceData, onSuccess = () => {}, onFailure = () => {}) {
  return requestUtil.jsonPostWithCredentials(apiUrl('/sources'), sourceData)
    .then(onSuccess)
    .catch(onFailure);
}

function getReferralLinkFromEmail(email, onSuccess = () => {}, onFailure = () => {}) {
  if (email) {
    return requestUtil.fetchWithCredentials(apiUrl(`/sources/email/${encodeURIComponent(email)}`))
      .then(onSuccess)
      .catch(err => onFailure(err));
  }
  return null;
}

function fetchSourceData(sourceId, onSuccess = () => {}, onFailure = () => {}) {
  return requestUtil.fetchWithCredentials(apiUrl(`/sources/sourceId/${sourceId}`))
    .then(onSuccess)
    .catch(onFailure);
}

module.exports = {
  sendTestFitFormEmail,
  createSource,
  getReferralLinkFromEmail,
  fetchSourceData
};
